import {
    ADD_NEWCUSTOMER_FAILED,
    ADD_NEWCUSTOMER_LOADING,
    ADD_NEWCUSTOMER_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    data :null
};

export const addNewCustomerReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case ADD_NEWCUSTOMER_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_NEWCUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_NEWCUSTOMER_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                data:null
            };
       
        default:
            return state;
    }
};




